<div class="mx-md-5 mx-3 d-flex justify-content-between border-bottom border-1" id="partner" style="border-color: #A0A0A0; padding-top: 175px;">
  <h2 class="text-uppercase" (mouseenter)="startAnimation()">(Our {{ titleTexts[textStep] }})</h2>
  <p>
    <span class="mac" style="right: 535px;">MAC</span>76B25 is proud to be partner with the global<br>
    pioneers for Real World Assets tokenization<br>
    and Decentralized Commerce
  </p>
</div>

<div class="p-md-5 p-3">
  <div class="row g-0">
    <div class="col-8 hide-mobile"></div>
    <div class="col">
      <div class="custom-grid">
        <div id="fermion"></div>
        <div id="boson"></div>
        <div id="pjpp"></div>
        <div></div>
        <div id="logo-3dome"></div>
        <div></div>
        <div class="highlight"></div>
        <div class="highlight"></div>
        <div></div>
        <div></div>
        <div></div>
        <div class="highlight"></div>
      </div>
    </div>
  </div>
</div>